<section class="panel">
  <h2>{{ 'pricing.title' | t }}</h2>
  <div class="grid three">
    <label>
      {{ 'pricing.pricebookName' | t }}
      <input [(ngModel)]="pricebookName" />
    </label>
    <label>
      {{ 'pricing.currency' | t }}
      <input [(ngModel)]="pricebookCurrency" />
    </label>
    <label>
      {{ 'pricing.pricebookId' | t }}
      <input [(ngModel)]="pricebookId" />
    </label>
  </div>
  <div class="actions">
    <button type="button" (click)="createPricebook()" [disabled]="busy">{{ 'pricing.createPricebook' | t }}</button>
    <button type="button" (click)="publishPricebook()" [disabled]="busy">{{ 'pricing.publishPricebook' | t }}</button>
  </div>

  <div class="grid four">
    <label>
      {{ 'pricing.ruleType' | t }}
      <select [(ngModel)]="priceRuleType">
        <option value="BASE_PRICE">{{ 'pricing.ruleType.base' | t }}</option>
        <option value="OPTION_DELTA">{{ 'pricing.ruleType.delta' | t }}</option>
        <option value="CONDITIONAL_ADJUSTMENT">{{ 'pricing.ruleType.conditional' | t }}</option>
      </select>
    </label>
    <label>
      {{ 'pricing.conditionType' | t }}
      <select [(ngModel)]="priceRuleConditionType">
        <option value="ALWAYS">{{ 'pricing.condition.always' | t }}</option>
        <option value="OPTION_SELECTED">{{ 'pricing.condition.optionSelected' | t }}</option>
      </select>
    </label>
    <label>
      {{ 'pricing.conditionOptionCode' | t }}
      <input [(ngModel)]="priceRuleConditionOptionCode" />
    </label>
    <label>
      {{ 'pricing.priority' | t }}
      <input type="number" [(ngModel)]="priceRulePriority" />
    </label>
    <label>
      {{ 'pricing.amount' | t }}
      <input [(ngModel)]="priceRuleAmount" />
    </label>
    <label>
      {{ 'pricing.breakdownCode' | t }}
      <input [(ngModel)]="priceRuleCode" />
    </label>
    <label>
      {{ 'pricing.reason' | t }}
      <input [(ngModel)]="priceRuleReason" />
    </label>
  </div>
  <div class="actions">
    <button type="button" (click)="addPriceRule()" [disabled]="busy">{{ 'pricing.addPriceRule' | t }}</button>
  </div>
</section>

<section class="panel" *ngIf="error">
  <p class="error">{{ error }}</p>
</section>

<section class="panel" *ngIf="info && !error">
  <p class="info">{{ info }}</p>
</section>
